import * as React from "react";
import { SVGProps } from "react";

const Qtum = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 550 496"
    {...props}
  >
    <style>{".st0{fill:#2e9ad0}"}</style>
    <g id="Lines">
      <path
        d="M333.4 481.3H182.2l-122-89.4-46.5-144.4 46.4-144.4 122-89.4h151.3l122 89.4 46.4 144.4-46.4 144.4-1.7 1.7-120.3 87.7zm-147.8-10.4H330L446.9 385l44.7-137.5L446.9 110 330 24.1H185.6L68.8 110 24.1 247.5 68.8 385l116.8 85.9z"
        className="st0"
      />
      <path
        d="m519.1 457.2-70.5-63.6-68.8-25.8-122 15.5-123.7-15.5-68.8 25.8-3.4-10.3 70.4-27.5h1.8L257.8 373l123.8-17.2 1.7 1.7 72.2 27.5 70.4 65.3z"
        className="st0"
      />
      <path
        d="m330 486.4-72.2-99.7-75.6 99.7-55-122 10.3-5.2 48.1 106.6 72.2-98 70.5 98 48.1-106.6 65.3-130.6 15.5 159.8h-10.3l-12.1-122-48.1 98z"
        className="st0"
      />
      <path d="M20.6 242.3h477.8v10.3H20.6z" className="st0" />
      <path
        d="m441.7 266.4-60.1-118.6L330 259.5l-72.2-128.9-73.9 128.9-51.6-111.7-60.1 118.6-13.8-158.1 10.4-1.7 10.3 123.7 53.2-104.8 51.6 111.7L257.8 110l70.5 127.2 53.3-111.7 53.2 103.1 8.6-122h10.4z"
        className="st0"
      />
      <path
        d="M376.4 139.2 328.3 30.9l-70.5 99.7-72.2-99.7-48.1 108.3-8.6-5.1 53.3-123.8 75.6 101.4L330 10.3l56.7 123.8zm70.5 249.2-12.1-122L381.6 373l-53.3-113.5-70.5 128.9-73.9-128.9L132.3 373 79.1 266.4l-10.3 122H58.4l13.8-159.8 60.1 120.3 51.6-111.7 73.9 128.9L330 237.2l51.6 113.4 60.1-122 15.5 159.8z"
        className="st0"
      />
      <path
        d="m381.6 142.7-125.5-17.2-123.8 17.2-70.4-31 3.4-10.3 68.8 29.2 122-15.4 125.5 15.4 67-29.2 5.2 10.3z"
        className="st0"
      />
    </g>
    <g id="Circles">
      <circle cx={183.9} cy={476.1} r={20.6} className="st0" />
      <circle cx={328.3} cy={476.1} r={20.6} className="st0" />
      <circle cx={183.9} cy={20.6} r={20.6} className="st0" />
      <circle cx={328.3} cy={20.6} r={20.6} className="st0" />
      <circle cx={448.6} cy={106.6} r={20.6} className="st0" />
      <circle cx={63.6} cy={106.6} r={20.6} className="st0" />
      <circle cx={63.6} cy={390.2} r={20.6} className="st0" />
      <circle cx={20.6} cy={247.5} r={20.6} className="st0" />
      <circle cx={496.7} cy={247.5} r={20.6} className="st0" />
      <circle cx={438.3} cy={247.5} r={20.6} className="st0" />
      <circle cx={75.6} cy={247.5} r={20.6} className="st0" />
      <circle cx={183.9} cy={247.5} r={20.6} className="st0" />
      <circle cx={328.3} cy={247.5} r={20.6} className="st0" />
      <circle
        cx={257.8}
        cy={120.3}
        r={20.6}
        className="st0"
        transform="rotate(-80.781 257.815 120.308)"
      />
      <circle cx={132.3} cy={137.5} r={20.6} className="st0" />
      <circle cx={381.6} cy={137.5} r={20.6} className="st0" />
      <circle cx={257.8} cy={378.1} r={20.6} className="st0" />
      <circle cx={132.3} cy={360.9} r={20.6} className="st0" />
      <circle cx={381.6} cy={360.9} r={20.6} className="st0" />
      <circle cx={522.5} cy={453.8} r={27.5} className="st0" />
    </g>
  </svg>
);

export default Qtum;
